import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import { withFormik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import api from '../../components/Api/Api';

const styles = {
  form: {
    padding: '30px'
  },
  fieldGroup: {
    marginTop: '20px'
  },
  fieldLabel: {
    marginTop: '20px'
  },
  field: {
    height: '30px'
  },
  updateButton: {
    marginTop: '20px',
    marginLeft: '20px'
  }
};

const TratamientoForm = props => {
  const { values, isSubmitting = false, isValid = true, errors } = props;

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  console.log(errors);
  return (
    <Form className={classes.form}>
      <ErrorLabel>{errors.generalError}</ErrorLabel>

      <GridItem xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
        <label htmlFor='Código' style={{ display: 'block' }}>
          Código:
        </label>
        <Field name='code' className={classes.field} value={values.code} />
        <ErrorMessage name='code' component={ErrorLabel} />
      </GridItem>

      <GridItem xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
        <label htmlFor='Nombre' style={{ display: 'block' }}>
          Nombre:
        </label>
        <Field name='name' className={classes.field} value={values.name} />
        <ErrorMessage name='name' component={ErrorLabel} />
      </GridItem>

      <GridItem xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
        <label htmlFor='Duracion' style={{ display: 'block' }}>
          Duración (días):
        </label>
        <Field name='days' className={classes.field} value={values.days} />
        <ErrorMessage name='days' component={ErrorLabel} />
      </GridItem>

      <Button
        color='info'
        className={classes.updateButton}
        type='submit'
        disabled={isSubmitting || !isValid}
      >
        Actualizar datos
      </Button>
    </Form>
  );
};
Yup.setLocale({
  mixed: {
    default: 'Valor no válido'
  }
});

export default withFormik({
  validationSchema: Yup.object().shape({
    code: Yup.string().required('El código es obligatorio'),
    name: Yup.string().required('El nombre es obligatorio'),
    days: Yup.number()
      .required('El número de días es obligatorio')
      .typeError('El campo debe ser un número')
      .integer()
      .min(1)
  }),

  handleSubmit: (values, { setSubmitting, setErrors }) => {
    setSubmitting(true);
    console.log(values);
    let method = 'POST';
    let url = 'tratamiento';

    if (values.id) {
      method = 'PUT';
      url = 'tratamiento/' + values.id;
    }

    api(url, method, values)
      .then(data => {
        console.log('tratamiento updated: ' + data);
        setSubmitting(false);
      })
      .catch(error => {
        setErrors({ generalError: 'Error updating tratamiento: ' + error });
        setSubmitting(false);
      });
  },
  isInitialValid: true
})(TratamientoForm);
